import {
    SearchWithFieldComponent
} from "../component/protected-components/search-with-field-component/search-with-field.component";
import {SiIndexRunComponent} from "../component/protected-components/si-index-run/si-index-run.component";
import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {SiConfigPage} from "../page/overview/si-config/si-config.page";
import {SiDashboardComponent} from "../page/overview/si-dashboard/si-dashboard.component";
import {SiKpiComponent} from "../page/si-overview-page/components/kpiComponent/si-kpi.component";
import {SiStatisticsComponent} from "../page/si-overview-page/components/statisticsComponent/si-statistics.component";


const siModuleEntry: TestModuleDefinition = {
    key: 'si',
    label: 'Search (si)',
    components: [
        {
            key: 'searchWithFieldComponent',
            component: SearchWithFieldComponent,
            selector: 'search-with-field-component',
            type: 'Component',
            label: 'Search With Field'
        },
        {
            key: 'siIndexRunComponent',
            component: SiIndexRunComponent,
            selector: 'si-index-run-object',
            type: 'Component',
            label: 'Index Run'
        },
        {
            key: 'SiConfigPage',
            component: SiConfigPage,
            selector: 'si-config-page',
            type: 'PageComponent',
            label: 'si config page'
        },
        {
            key: 'SiDashboardComponent',
            component: SiDashboardComponent,
            selector: 'si-dashboard',
            type: 'PageComponent',
            label: 'si dashboard'
        },
        {
            key: 'SiKpiComponent',
            component: SiKpiComponent,
            selector: 'si-kpi-component',
            type: 'OverviewKpiBaseComponent',
            label: 'si kpi component'
        },
        {
            key: 'SiStatisticsComponent',
            component: SiStatisticsComponent,
            selector: 'si-statistics-component',
            type: 'OverviewStatisticsBaseComponent',
            label: 'si statistics component'
        }
    ]
}

export const SI_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: siModuleEntry, multi: true}
];